import debounce from "lodash/debounce";

let observers = [];

const setupHeights = (el) => {
  const contentColumn = el.querySelector(".content-column");
  const listColumn = el.querySelector(".list-column");
  const lastElement = listColumn.querySelector("li:last-child");

  const isTwoColumn = window.matchMedia("(min-width: 768px)").matches;
  const contentHeight = contentColumn.offsetHeight;
  const listHeight = listColumn.offsetHeight;

  if (isTwoColumn && listHeight > contentHeight) {
    const offset = contentColumn.offsetHeight - lastElement.offsetHeight;
    listColumn.style.paddingBottom = `${offset}px`;
  } else {
    listColumn.style.paddingBottom = null;
  }
};

const setupObservers = (el) => {
  const listColumn = el.querySelector(".list-column");

  const observer = new IntersectionObserver(
    ([e]) => {
      e.target.classList.toggle("is-out", !e.isIntersecting);
    },
    {
      threshold: [1],
    },
  );

  listColumn.querySelectorAll("li").forEach((li) => {
    observer.observe(li);
    observers.push(observer);
  });
};

document.querySelectorAll(".element-scrollablecalloutlist").forEach((el) => {
  setupHeights(el);
  setupObservers(el);
});

window.addEventListener(
  "resize",
  debounce(() => {
    observers.forEach((observer) => observer.disconnect());

    observers = [];

    document.querySelectorAll(".element-scrollablecalloutlist").forEach((el) => {
      setupHeights(el);
      setupObservers(el);
    });
  }, 250),
);
